// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  .coupon-card-wraper {
    width: 27%;
    margin-left: 16px;
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  }

  .coupon-icon {
    width: 22px;
    height: 22px;
    margin-left: 6px;
    margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 20px;
      height: 20px;
    }
  }
  .my-wallet-heading {
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
    font-size: ${(props) => props.theme.typography.fontSizes.fs20};
    text-transform: uppercase;
    color: ${(props) => props.theme.colorPalette.gray[900]};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-weight: 700;
      font-size: ${(props) => props.theme.typography.fontSizes.fs16};
    }
  }
  .wallet-view-all {
    text-decoration: underline;
    margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    font-size: ${(props) => props.theme.typography.fontSizes.fs16};
    line-height: 22px;
    margin-right: 19px;
  }

  .coupon-status-heading {
    display: flex;
    align-items: center;
    .coupon-status-left {
      display: flex;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      justify-content: space-between;
    }
  }

  .tileWrapper {
    margin-bottom: 0;
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    min-height: 135px;
    border-bottom: 0;
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    background: ${(props) => props.theme.colors.WHITE};
    width: 28.5%;
  }

  .my-wallet-edit-link {
    padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    bottom: 0;
  }
  .account-dashboard-carousel-new {
    .slick-slider {
      padding: 0;
    }
    .slick-dots {
      justify-content: flex-start;
      margin-left: 25px;
      margin-bottom: -20px;
    }
    .slick-dots li {
      margin: 0 12px 0 0;
      width: 40px;
      height: 2px;
    }
    .slick-dots li button {
      width: 40px;
      height: 2px;
    }
    .slick-dots li button:before {
      width: 40px;
      height: 2px;
      border-radius: 0;
      background: #b0b0b0;
    }
    .slick-dots li.slick-active button:before {
      background: ${(props) => props.theme.colorPalette.blue[900]};
    }
    .couponCard__header_text {
      font-size: ${(props) => props.theme.typography.fontSizes.fs12};
      font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
    }
  }
  .view-all-offers-link-wrapper {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    margin-bottom: 15px;
  }
`;

export default styles;
